import { FC } from 'react'
import useProjectRoles from 'screens/Admin/ProjectRoles/hooks/useProjectRoles'
import { IProjectSlot, ProjectSlotRole as IProjectSlotRole } from 'screens/Projects/projects.types'
import projectSlotApi from 'screens/Projects/projectSlot.api'
import Button from 'shared/Buttons/Button/Button'
import TextField from 'shared/Forms/TextField'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import useStateWithChange from 'shared/hooks/useStateWithChange'
import Dropdown from 'shared/Inputs/Dropdown'
import NumberInput from 'shared/Inputs/NumberInput'
import Sheet from 'shared/Sheet'

interface IProps {
  id?: IProjectSlotRole['id']
  slotId: IProjectSlot['id']
  slotRole: Omit<IProjectSlotRole, 'id'>
  onSave: (value: IProjectSlotRole, isNew?: boolean) => void
  onDelete: () => void
}

const ProjectSlotRole: FC<IProps> = (props) => {
  const [draftRole, _, handleChange] = useStateWithChange(props.slotRole)
  const { loadMore, projectRolesState, loading: loadingProjectRoles } = useProjectRoles()
  const role = draftRole.role ? { ...draftRole.role, description: '' } : null

  const { wait, loading } = useHttpLoader()

  const handleSave = () => {
    const dto = { ...draftRole, roleId: draftRole.role.id, slotId: props.slotId }
    if (props.id) {
      wait(projectSlotApi.updateProjectSlotRole(props.id, dto), (resp) => {
        if (resp.status === 'success') {
          props.onSave({ ...resp.body, role: draftRole.role, roleId: draftRole.roleId })
        }
      })
      return
    }

    wait(projectSlotApi.createProjectSlotRole(dto), (resp) => {
      if (resp.status === 'success') {
        props.onSave({ ...resp.body, role: draftRole.role, roleId: draftRole.roleId }, true)
      }
    })
  }

  const handleDelete = () => {
    if (props.id) {
      wait(projectSlotApi.deleteProjectSlotRole(props.id), (resp) => {
        if (resp.status === 'success') {
          props.onDelete()
        }
      })
      return
    }
    props.onDelete()
  }

  return (
    <Sheet>
      <div className='flex-lines'>
        <TextField header='Роль'>
          <Dropdown
            options={projectRolesState.items}
            selectedOption={role}
            title='Роли'
            name='role'
            onSelect={handleChange}
            getOptionKey={(o) => o?.id}
            getOptionLabel={(o) => o?.title}
            loading={loadingProjectRoles}
            allowEmpty={false}
            infinityLoadProps={{
              loadMore,
              isMore: projectRolesState.nextPage !== null,
            }}
          />
        </TextField>
        <TextField header='Максимальное кол-во участников'>
          <NumberInput value={draftRole.maxMembers} onChange={handleChange} name='maxMembers' />
        </TextField>
        <TextField header='Минимальное кол-во участников'>
          <NumberInput value={draftRole.minMembers} onChange={handleChange} name='minMembers' />
        </TextField>
        <div className='flex-space-between'>
          <Button loading={loading} theme='primary' style={{ width: 'fit-content' }} onClick={handleSave}>
            {props.id ? 'Сохранить' : 'Создать'}
          </Button>
          <Button loading={loading} theme='danger' style={{ width: 'fit-content' }} onClick={handleDelete}>
            {props.id ? 'Удалить' : 'Отменить'}
          </Button>
        </div>
      </div>
    </Sheet>
  )
}

export default ProjectSlotRole
